import React from "react";
import "./contact.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faTwitter, faInstagram, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import EnvelopeAnimation from "./Envolap";
import Header from "../Home/Header";
import Swal from "sweetalert2";

const ContactForm = () => {
  const handleFocus = (e) => {
    e.target.parentNode.classList.add("focus");
  };

  const handleBlur = (e) => {
    if (e.target.value === "") {
      e.target.parentNode.classList.remove("focus");
    }
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    // Add access key for API
    formData.append("access_key", "44165200-6289-4472-8486-185d74818a5e");

    const jsonData = JSON.stringify(Object.fromEntries(formData));

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: jsonData,
      });

      const result = await response.json();

      if (result.success) {
        Swal.fire({
          title: "Success!",
          text: "Your message has been sent.",
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            popup: "custom-orange-popup", // Apply custom CSS class
            title: "custom-orange-title",
            confirmButton: "custom-orange-button",
          },
        });
        event.target.reset(); // Reset the form after successful submission
      } else {
        Swal.fire({
          title: "Error",
          text: "Form submission failed. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
        console.error("Form submission failed:", result);
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "An unexpected error occurred. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
      console.error("Error submitting form:", error);
    }
  };

  return (
    <>
      <div className="containerss">
        <span className="big-circle"></span>
        <img src="img/shape.png" className="square" alt="Decorative Shape" />

        <div className="form">
          {/* Contact Info Section */}
          <div className="contact-info">
            <h3 className="title">Let's get in touch</h3>
            <p className="text">
              Feel free to reach out for any queries or collaboration opportunities. We'd love to hear from you!
            </p>

            <div className="info">
              <EnvelopeAnimation />
            </div>

            <div className="social-media">
              <p>Connect with us:</p>
              <div className="social-icons">
                <a href="https://facebook.com" target="_blank" rel="noreferrer">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noreferrer">
                  <FontAwesomeIcon icon={faTwitter} />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noreferrer">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noreferrer">
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </a>
              </div>
            </div>
          </div>

          {/* Contact Form Section */}
          <div className="contact-form">
            <span className="circle one"></span>
            <span className="circle two"></span>

            <form autoComplete="off" onSubmit={onSubmit}>
              <h3 className="title">Contact us</h3>

              <div className="input-container">
                <input
                  type="text"
                  name="name"
                  className="input"
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  required
                />
                <label>Name</label>
                <span>Username</span>
              </div>

              <div className="input-container">
                <input
                  type="email"
                  name="email"
                  className="input"
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  required
                />
                <label>Email</label>
                <span>Email</span>
              </div>

              <div className="input-container">
                <input
                  type="tel"
                  name="phone"
                  className="input"
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  required
                />
                <label>Phone</label>
                <span>Phone</span>
              </div>

              <div className="input-container textarea">
                <textarea
                  name="message"
                  className="input"
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  required
                ></textarea>
                <label>Message</label>
                <span>Message</span>
              </div>

              <input type="submit" value="Send" className="btn" />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactForm;


// import React, { useState, useEffect } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faFacebookF,
//   faTwitter,
//   faInstagram,
//   faLinkedinIn,
// } from "@fortawesome/free-brands-svg-icons";
// import {
//   faPaperPlane,
//   faUser,
//   faPhone,
//   faEnvelope,
//   faMessage,
//   faMapMarkerAlt,
//   faClock,
//   faShieldAlt,
//   faCheck,
//   faSun,
// } from "@fortawesome/free-solid-svg-icons";
// import Swal from "sweetalert2";

// const ContactForm = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     message: ""
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [activeField, setActiveField] = useState(null);

//   // Floating particles effect
//   useEffect(() => {
//     const createParticles = () => {
//       const container = document.querySelector('.particles-container');
//       if (!container) return;

//       for (let i = 0; i < 20; i++) {
//         const particle = document.createElement('div');
//         particle.className = 'absolute rounded-full bg-orange-200/20';
//         particle.style.width = `${Math.random() * 20 + 10}px`;
//         particle.style.height = particle.style.width;
//         particle.style.left = `${Math.random() * 100}%`;
//         particle.style.top = `${Math.random() * 100}%`;
//         particle.style.animation = `float ${Math.random() * 5 + 5}s ease-in-out infinite`;
//         particle.style.animationDelay = `${Math.random() * 5}s`;
//         container.appendChild(particle);
//       }
//     };

//     createParticles();
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     const formDataObj = new FormData(e.target);
//     formDataObj.append("access_key", "44165200-6289-4472-8486-185d74818a5e");

//     try {
//       const response = await fetch("https://api.web3forms.com/submit", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(Object.fromEntries(formDataObj))
//       });

//       const result = await response.json();

//       if (result.success) {
//         Swal.fire({
//           title: "🎉 Message Sent!",
//           text: "We'll get back to you within 24 hours.",
//           icon: "success",
//           background: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
//           color: 'white',
//           confirmButtonColor: '#ea580c',
//           timer: 3000,
//           showConfirmButton: false
//         });

//         // Reset form
//         setFormData({ name: "", email: "", phone: "", message: "" });
//         setActiveField(null);
//       } else {
//         throw new Error('Submission failed');
//       }
//     } catch (error) {
//       Swal.fire({
//         title: "Oops!",
//         text: "Something went wrong. Please try again.",
//         icon: "error",
//         confirmButtonColor: '#f97316',
//       });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleFocus = (field) => {
//     setActiveField(field);
//   };

//   const handleBlur = () => {
//     setActiveField(null);
//   };

//   const socialLinks = [
//     { icon: faFacebookF, color: "hover:bg-blue-600", label: "Facebook", bg: "bg-blue-500" },
//     { icon: faTwitter, color: "hover:bg-sky-500", label: "Twitter", bg: "bg-sky-400" },
//     { icon: faInstagram, color: "hover:bg-pink-600", label: "Instagram", bg: "bg-gradient-to-br from-pink-500 to-orange-500" },
//     { icon: faLinkedinIn, color: "hover:bg-blue-700", label: "LinkedIn", bg: "bg-blue-600" }
//   ];

//   const contactDetails = [
//     { icon: faMapMarkerAlt, title: "Our Location", text: "123 Orange Street, Sunny City", color: "bg-orange-500" },
//     { icon: faPhone, title: "Phone Number", text: "+1 (555) 123-4567", color: "bg-amber-500" },
//     { icon: faEnvelope, title: "Email Address", text: "hello@orangecreative.com", color: "bg-yellow-500" },
//     { icon: faClock, title: "Response Time", text: "Within 24 hours", color: "bg-orange-400" }
//   ];

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50 py-12 px-4 relative overflow-hidden">
//       {/* Animated Particles */}
//       <div className="particles-container absolute inset-0 overflow-hidden pointer-events-none" />

//       {/* Sun Background Effect */}
//       <div className="absolute top-1/4 right-10 w-96 h-96 bg-gradient-to-br from-orange-200/30 to-amber-200/20 rounded-full blur-3xl animate-pulse" />
//       <div className="absolute bottom-1/4 left-10 w-80 h-80 bg-gradient-to-tr from-yellow-200/20 to-orange-200/10 rounded-full blur-3xl" />

//       {/* Main Container */}
//       <div className="max-w-7xl mx-auto relative z-10">
//         {/* Header */}
//         <div className="text-center mb-16 animate-fade-in">
//           <div className="inline-flex items-center justify-center mb-4">
//             <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-amber-500 rounded-full flex items-center justify-center shadow-lg shadow-orange-200">
//               <FontAwesomeIcon icon={faSun} className="text-white text-2xl" />
//             </div>
//           </div>
//           <h1 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent mb-4">
//             Let's Create Together
//           </h1>
//           <p className="text-xl text-gray-600 max-w-2xl mx-auto">
//             Got a bright idea? Let's make it shine! Share your vision with us and watch it come to life.
//           </p>
//         </div>

//         <div className="grid lg:grid-cols-2 gap-8">
//           {/* Left Side - Contact Info */}
//           <div className="space-y-8">
//             {/* Stats Cards */}
//             <div className="grid grid-cols-2 gap-6">
//               {[
//                 { value: "100+", label: "Happy Clients", color: "from-orange-500 to-amber-500" },
//                 { value: "24/7", label: "Support", color: "from-amber-500 to-yellow-500" },
//                 { value: "40+", label: "Projects Done", color: "from-yellow-500 to-orange-400" },
//                 { value: "99%", label: "Satisfaction", color: "from-orange-400 to-red-500" }
//               ].map((stat, idx) => (
//                 <div 
//                   key={idx}
//                   className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-orange-100"
//                 >
//                   <div className={`text-3xl font-bold bg-gradient-to-r ${stat.color} bg-clip-text text-transparent mb-2`}>
//                     {stat.value}
//                   </div>
//                   <div className="text-gray-600 font-medium">{stat.label}</div>
//                 </div>
//               ))}
//             </div>

//             {/* Contact Details Card */}
//             <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-8 shadow-2xl shadow-orange-100/50 border border-orange-100">
//               <h2 className="text-3xl font-bold bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent mb-8">
//                 Get in Touch
//               </h2>
              
//               <div className="space-y-6 mb-8">
//                 {contactDetails.map((detail, idx) => (
//                   <div 
//                     key={idx}
//                     className="flex items-center gap-4 p-4 rounded-xl hover:bg-orange-50 transition-all duration-300 group hover:translate-x-2"
//                   >
//                     <div className={`${detail.color} w-12 h-12 rounded-xl flex items-center justify-center shadow-lg transition-transform duration-300 group-hover:scale-110`}>
//                       <FontAwesomeIcon icon={detail.icon} className="text-white text-lg" />
//                     </div>
//                     <div>
//                       <h3 className="font-semibold text-gray-800">{detail.title}</h3>
//                       <p className="text-gray-600">{detail.text}</p>
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {/* Social Links */}
//               <div>
//                 <h3 className="text-lg font-semibold text-gray-800 mb-4">Connect With Us</h3>
//                 <div className="flex gap-4">
//                   {socialLinks.map((social, idx) => (
//                     <a
//                       key={idx}
//                       href="#"
//                       className={`${social.bg} ${social.color} w-12 h-12 rounded-xl flex items-center justify-center text-white shadow-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-xl relative group`}
//                       aria-label={social.label}
//                     >
//                       <FontAwesomeIcon icon={social.icon} />
//                       <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
//                         {social.label}
//                       </div>
//                     </a>
//                   ))}
//                 </div>
//               </div>

//               {/* Security Badge */}
//               <div className="mt-8 bg-gradient-to-r from-orange-50 to-amber-50 rounded-2xl p-5 border border-orange-100">
//                 <div className="flex items-center gap-3">
//                   <div className="w-10 h-10 bg-orange-100 rounded-xl flex items-center justify-center">
//                     <FontAwesomeIcon icon={faShieldAlt} className="text-orange-600" />
//                   </div>
//                   <div>
//                     <p className="text-sm font-medium text-orange-800">Your data is protected</p>
//                     <p className="text-xs text-orange-600">Secure & encrypted connection</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right Side - Contact Form */}
//           <div className="bg-gradient-to-br from-white to-orange-50 rounded-3xl p-8 shadow-2xl shadow-orange-200/50 border border-orange-100 relative overflow-hidden">
//             {/* Decorative Elements */}
//             <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-orange-200/20 to-amber-200/10 rounded-full -translate-y-16 translate-x-16" />
//             <div className="absolute bottom-0 left-0 w-40 h-40 bg-gradient-to-tr from-yellow-200/10 to-orange-200/10 rounded-full -translate-x-16 translate-y-16" />

//             <div className="relative z-10">
//               <div className="mb-8">
//                 <h2 className="text-3xl font-bold bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent mb-2">
//                   Send Your Message
//                 </h2>
//                 <p className="text-gray-600">Fill out the form below and we'll get back to you soon</p>
//               </div>

//               <form onSubmit={handleSubmit} className="space-y-6">
//                 {/* Name Field */}
//                 <div className="relative">
//                   <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
//                     <FontAwesomeIcon icon={faUser} />
//                   </div>
//                   <input
//                     type="text"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     onFocus={() => handleFocus('name')}
//                     onBlur={handleBlur}
//                     className={`w-full pl-12 pr-4 py-4 bg-white border-2 rounded-2xl focus:outline-none transition-all duration-300 ${
//                       activeField === 'name' 
//                         ? 'border-orange-500 shadow-lg shadow-orange-200' 
//                         : 'border-orange-100 hover:border-orange-300'
//                     }`}
//                     placeholder="Your Full Name"
//                     required
//                   />
//                   {formData.name && (
//                     <div className="absolute right-4 top-1/2 -translate-y-1/2">
//                       <FontAwesomeIcon icon={faCheck} className="text-green-500" />
//                     </div>
//                   )}
//                 </div>

//                 {/* Email Field */}
//                 <div className="relative">
//                   <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
//                     <FontAwesomeIcon icon={faEnvelope} />
//                   </div>
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     onFocus={() => handleFocus('email')}
//                     onBlur={handleBlur}
//                     className={`w-full pl-12 pr-4 py-4 bg-white border-2 rounded-2xl focus:outline-none transition-all duration-300 ${
//                       activeField === 'email' 
//                         ? 'border-orange-500 shadow-lg shadow-orange-200' 
//                         : 'border-orange-100 hover:border-orange-300'
//                     }`}
//                     placeholder="Your Email Address"
//                     required
//                   />
//                   {formData.email && (
//                     <div className="absolute right-4 top-1/2 -translate-y-1/2">
//                       <FontAwesomeIcon icon={faCheck} className="text-green-500" />
//                     </div>
//                   )}
//                 </div>

//                 {/* Phone Field */}
//                 <div className="relative">
//                   <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
//                     <FontAwesomeIcon icon={faPhone} />
//                   </div>
//                   <input
//                     type="tel"
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleChange}
//                     onFocus={() => handleFocus('phone')}
//                     onBlur={handleBlur}
//                     className={`w-full pl-12 pr-4 py-4 bg-white border-2 rounded-2xl focus:outline-none transition-all duration-300 ${
//                       activeField === 'phone' 
//                         ? 'border-orange-500 shadow-lg shadow-orange-200' 
//                         : 'border-orange-100 hover:border-orange-300'
//                     }`}
//                     placeholder="Your Phone Number"
//                     required
//                   />
//                   {formData.phone && (
//                     <div className="absolute right-4 top-1/2 -translate-y-1/2">
//                       <FontAwesomeIcon icon={faCheck} className="text-green-500" />
//                     </div>
//                   )}
//                 </div>

//                 {/* Message Field */}
//                 <div className="relative">
//                   <div className="absolute left-4 top-6 text-gray-400">
//                     <FontAwesomeIcon icon={faMessage} />
//                   </div>
//                   <textarea
//                     name="message"
//                     value={formData.message}
//                     onChange={handleChange}
//                     onFocus={() => handleFocus('message')}
//                     onBlur={handleBlur}
//                     rows="5"
//                     className={`w-full pl-12 pr-4 py-4 bg-white border-2 rounded-2xl focus:outline-none transition-all duration-300 resize-none ${
//                       activeField === 'message' 
//                         ? 'border-orange-500 shadow-lg shadow-orange-200' 
//                         : 'border-orange-100 hover:border-orange-300'
//                     }`}
//                     placeholder="Tell us about your project..."
//                     required
//                   />
//                   <div className="absolute bottom-3 right-3 text-xs text-gray-400">
//                     {formData.message.length}/500
//                   </div>
//                 </div>

//                 {/* Submit Button */}
//                 <button
//                   type="submit"
//                   disabled={isSubmitting}
//                   className="w-full py-4 px-6 bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white font-semibold rounded-2xl shadow-lg shadow-orange-200 hover:shadow-xl hover:shadow-orange-300 transition-all duration-300 transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center gap-3 group"
//                 >
//                   {isSubmitting ? (
//                     <>
//                       <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
//                       <span>Sending...</span>
//                     </>
//                   ) : (
//                     <>
//                       <span>Send Message</span>
//                       <FontAwesomeIcon 
//                         icon={faPaperPlane} 
//                         className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" 
//                       />
//                     </>
//                   )}
//                 </button>

//                 {/* Privacy Note */}
//                 <div className="text-center pt-4">
//                   <p className="text-sm text-gray-500 flex items-center justify-center gap-2">
//                     <FontAwesomeIcon icon={faShieldAlt} className="text-orange-500" />
//                     <span>Your information is safe with us. We never share your data.</span>
//                   </p>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>

//         {/* Testimonial Section */}
//         <div className="mt-16 text-center">
//           <h3 className="text-2xl font-bold text-gray-800 mb-8">What Our Clients Say</h3>
//           <div className="grid md:grid-cols-3 gap-8">
//             {[
//               { name: "Sarah Johnson", role: "Marketing Director", text: "Their team turned our vision into reality with incredible attention to detail.", color: "bg-gradient-to-r from-orange-100 to-amber-100" },
//               { name: "Michael Chen", role: "Startup Founder", text: "Professional, creative, and delivered beyond expectations. Highly recommended!", color: "bg-gradient-to-r from-amber-100 to-yellow-100" },
//               { name: "Emma Rodriguez", role: "Product Manager", text: "The communication was exceptional throughout the entire project lifecycle.", color: "bg-gradient-to-r from-yellow-100 to-orange-100" }
//             ].map((testimonial, idx) => (
//               <div 
//                 key={idx}
//                 className={`${testimonial.color} rounded-3xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-orange-100`}
//               >
//                 <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-amber-500 rounded-full flex items-center justify-center text-white font-bold text-lg mb-4 mx-auto">
//                   {testimonial.name.charAt(0)}
//                 </div>
//                 <p className="text-gray-600 italic mb-4">"{testimonial.text}"</p>
//                 <div>
//                   <p className="font-semibold text-gray-800">{testimonial.name}</p>
//                   <p className="text-sm text-gray-500">{testimonial.role}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Add custom animations */}
//       <style jsx>{`
//         @keyframes float {
//           0%, 100% { transform: translateY(0) rotate(0deg); }
//           50% { transform: translateY(-20px) rotate(5deg); }
//         }
        
//         @keyframes fadeIn {
//           from { opacity: 0; transform: translateY(20px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
        
//         .animate-fade-in {
//           animation: fadeIn 0.8s ease-out;
//         }
        
//         /* Custom scrollbar */
//         ::-webkit-scrollbar {
//           width: 8px;
//         }
        
//         ::-webkit-scrollbar-track {
//           background: #fef3c7;
//         }
        
//         ::-webkit-scrollbar-thumb {
//           background: linear-gradient(to bottom, #f97316, #f59e0b);
//           border-radius: 4px;
//         }
        
//         ::-webkit-scrollbar-thumb:hover {
//           background: linear-gradient(to bottom, #ea580c, #d97706);
//         }
        
//         /* Selection color */
//         ::selection {
//           background-color: rgba(249, 115, 22, 0.3);
//           color: #7c2d12;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default ContactForm;






















// import React, { useState, useRef, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { 
//   FaUser, 
//   FaEnvelope, 
//   FaPhone, 
//   FaMapMarkerAlt, 
//   FaHome,
//   FaBuilding,
//   FaGlobe,
//   FaPaperPlane,
//   FaCheckCircle,
//   FaArrowRight,
//   FaStar,
//   FaClock,
//   FaUsers,
//   FaShieldAlt,
//   FaPlay,
//   FaPause
// } from 'react-icons/fa';

// const ContactPage = () => {
//   const navigate = useNavigate();
//   const videoRef = useRef(null);
//   const [isPlaying, setIsPlaying] = useState(true);
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     company: '',
//     address: {
//       street: '',
//       city: '',
//       state: '',
//       country: '',
//       zipCode: ''
//     },
//     projectType: '',
//     message: ''
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [activeField, setActiveField] = useState('');

//   // Video play/pause control
//   const toggleVideo = () => {
//     if (videoRef.current) {
//       if (isPlaying) {
//         videoRef.current.pause();
//       } else {
//         videoRef.current.play();
//       }
//       setIsPlaying(!isPlaying);
//     }
//   };

//   // Ensure video plays properly on mount
//   useEffect(() => {
//     if (videoRef.current) {
//       videoRef.current.play().catch(e => {
//         console.log("Autoplay prevented:", e);
//         // Fallback: show play button
//       });
//     }
//   }, []);

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.name.trim()) errors.name = 'Name is required';
//     if (!formData.email.trim()) errors.email = 'Email is required';
//     else if (!/\S+@\S+\.\S+/.test(formData.email)) errors.email = 'Email is invalid';
//     if (!formData.message.trim()) errors.message = 'Message is required';
//     return errors;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
    
//     if (name.includes('.')) {
//       const [parent, child] = name.split('.');
//       setFormData(prev => ({
//         ...prev,
//         [parent]: {
//           ...prev[parent],
//           [child]: value
//         }
//       }));
//     } else {
//       setFormData(prev => ({
//         ...prev,
//         [name]: value
//       }));
//     }
    
//     // Clear error for this field if it exists
//     if (name in formData || name.includes('address.')) {
//       // Error handling logic would go here
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     const errors = validateForm();
//     if (Object.keys(errors).length > 0) {
//       // Set errors state
//       return;
//     }

//     setIsSubmitting(true);

//     try {
//       // Simulate API call
//       setTimeout(() => {
//         setIsSubmitting(false);
//         setIsSubmitted(true);
        
//         setTimeout(() => {
//           setIsSubmitted(false);
//           setFormData({
//             name: '',
//             email: '',
//             phone: '',
//             company: '',
//             address: { street: '', city: '', state: '', country: '', zipCode: '' },
//             projectType: '',
//             message: ''
//           });
//         }, 3000);
//       }, 1500);
//     } catch (error) {
//       console.error('Error:', error);
//       alert('Failed to send message. Please try again.');
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-white via-orange-50/30 to-white">
//       {/* Enhanced Video Hero Section with Play Controls */}
//       <section className="relative h-[25vh] sm:h-[30vh] lg:h-[35vh] overflow-hidden bg-gray-900">
//         {/* Video Container with Proper Responsive Styling */}
//         <div className="absolute inset-0 w-full h-full">
//           <video
//             ref={videoRef}
//             autoPlay
//             muted
//             loop
//             playsInline
//             className="absolute inset-0 w-full h-full object-cover"
//             poster="/assets/Images/video-poster.jpg"
//             style={{ 
//               width: '100%', 
//               height: 'auto',
//               maxWidth: '100%' // Added for better responsiveness[citation:1]
//             }}
//           >
//             <source 
//               src="/assets/Images/mobilevideo.mp4" 
//               type="video/mp4" 
//             />
//             <source 
//               src="/assets/Images/mobilevideo.webm" 
//               type="video/webm" 
//             />
//             Your browser does not support the video tag.
//           </video>
          
//           {/* Video Overlay with Controls */}
//           <div className="absolute inset-0 bg-gradient-to-r from-orange-900/40 via-orange-700/30 to-transparent">
//             <div className="container mx-auto h-full flex items-center px-4 sm:px-6 lg:px-8">
//               <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 w-full">
//                 {/* Left Side - Enhanced Visual Content */}
//                 <div className="text-white space-y-6">
//                   <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
//                     <FaStar className="text-orange-400" />
//                     <span className="text-sm font-medium">Premium Cabinetry Solutions</span>
//                   </div>
                  
//                   <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
//                     Craft Your Dream <span className="text-orange-400">Space</span> With Us
//                   </h1>
                  
//                   <p className="text-xl text-white/90 max-w-2xl">
//                     Experience the perfect blend of craftsmanship and innovation. 
//                     Let's transform your vision into reality.
//                   </p>
                  
//                   {/* Stats Grid */}
//                   <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-4">
//                     <div className="text-center">
//                       <div className="text-3xl font-bold">500+</div>
//                       <div className="text-sm text-white/80">Projects</div>
//                     </div>
//                     <div className="text-center">
//                       <div className="text-3xl font-bold">15+</div>
//                       <div className="text-sm text-white/80">Years Experience</div>
//                     </div>
//                     <div className="text-center">
//                       <div className="text-3xl font-bold">24h</div>
//                       <div className="text-sm text-white/80">Response Time</div>
//                     </div>
//                     <div className="text-center">
//                       <div className="text-3xl font-bold">4.9</div>
//                       <div className="text-sm text-white/80">Rating</div>
//                     </div>
//                   </div>
//                 </div>
                
//                 {/* Right Side - Video Control */}
//                 <div className="hidden lg:flex items-center justify-end">
//                   <button 
//                     onClick={toggleVideo}
//                     className="group bg-white/20 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/30 transition-all duration-300 transform hover:scale-105"
//                   >
//                     <div className="flex flex-col items-center space-y-3">
//                       <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center group-hover:bg-orange-100 transition-colors">
//                         {isPlaying ? (
//                           <FaPause className="text-orange-600 text-2xl" />
//                         ) : (
//                           <FaPlay className="text-orange-600 text-2xl" />
//                         )}
//                       </div>
//                       <span className="text-white font-medium">
//                         {isPlaying ? 'Pause Video' : 'Play Video'}
//                       </span>
//                     </div>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Main Contact Section */}
//       <section className="relative -mt-8 sm:-mt-12 lg:-mt-16 px-4 sm:px-6 lg:px-8">
//         <div className="max-w-7xl mx-auto">
//           {/* Enhanced Floating Contact Card with Better Left Side */}
//           <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-orange-100">
//             <div className="grid lg:grid-cols-3">
//               {/* Left: Enhanced Contact Info & Features */}
//               <div className="bg-gradient-to-br from-orange-600 via-orange-500 to-orange-400 p-8 lg:p-12 text-white lg:col-span-1">
//                 <div className="mb-10">
//                   <div className="flex items-center space-x-3 mb-6">
//                     <div className="bg-white/20 p-3 rounded-xl backdrop-blur-sm">
//                       <FaShieldAlt className="text-2xl" />
//                     </div>
//                     <h2 className="text-3xl font-bold">Why Choose Laminance</h2>
//                   </div>
                  
//                   <div className="space-y-6">
//                     <div className="flex items-start space-x-4 p-4 bg-white/10 rounded-2xl backdrop-blur-sm">
//                       <div className="bg-white/20 p-2 rounded-lg">
//                         <FaUsers className="text-xl" />
//                       </div>
//                       <div>
//                         <h3 className="font-semibold text-lg">Expert Team</h3>
//                         <p className="text-orange-100 text-sm mt-1">
//                           Certified craftsmen with 15+ years experience
//                         </p>
//                       </div>
//                     </div>

//                     <div className="flex items-start space-x-4 p-4 bg-white/10 rounded-2xl backdrop-blur-sm">
//                       <div className="bg-white/20 p-2 rounded-lg">
//                         <FaClock className="text-xl" />
//                       </div>
//                       <div>
//                         <h3 className="font-semibold text-lg">On-Time Delivery</h3>
//                         <p className="text-orange-100 text-sm mt-1">
//                           We respect your time with guaranteed deadlines
//                         </p>
//                       </div>
//                     </div>

//                     <div className="flex items-start space-x-4 p-4 bg-white/10 rounded-2xl backdrop-blur-sm">
//                       <div className="bg-white/20 p-2 rounded-lg">
//                         <FaShieldAlt className="text-xl" />
//                       </div>
//                       <div>
//                         <h3 className="font-semibold text-lg">Warranty</h3>
//                         <p className="text-orange-100 text-sm mt-1">
//                           5-year warranty on all our cabinetry work
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Contact Quick Access */}
//                 <div className="space-y-6 border-t border-white/20 pt-8">
//                   <div>
//                     <h3 className="font-semibold text-xl mb-4">Quick Contact</h3>
//                     <div className="space-y-4">
//                       <a 
//                         href="tel:8624506069"
//                         className="flex items-center justify-between p-3 bg-white/10 rounded-xl hover:bg-white/20 transition"
//                       >
//                         <span>Call Now</span>
//                         <span className="font-bold">(862) 450-6069</span>
//                       </a>
//                       <a 
//                         href="mailto:Contactus@laminance.com"
//                         className="flex items-center justify-between p-3 bg-white/10 rounded-xl hover:bg-white/20 transition"
//                       >
//                         <span>Email Us</span>
//                         <span className="font-bold">Contactus@laminance.com</span>
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Right: Contact Form (2/3 width) */}
//               <div className="p-8 lg:p-12 lg:col-span-2">
//                 {!isSubmitted ? (
//                   <form onSubmit={handleSubmit} className="space-y-6">
//                     {/* Form fields remain the same as before */}
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                       {/* Name Field */}
//                       <div className="relative">
//                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                           <FaUser className="inline mr-2 text-orange-500" />
//                           Full Name *
//                         </label>
//                         <div className={`relative rounded-xl border-2 ${activeField === 'name' ? 'border-orange-500 ring-2 ring-orange-100' : 'border-gray-200'} bg-white transition-all`}>
//                           <input
//                             type="text"
//                             name="name"
//                             value={formData.name}
//                             onChange={handleChange}
//                             onFocus={() => setActiveField('name')}
//                             onBlur={() => setActiveField('')}
//                             required
//                             className="w-full pl-4 pr-4 py-3.5 bg-transparent outline-none placeholder-gray-400 text-gray-800"
//                             placeholder="Enter your full name"
//                           />
//                         </div>
//                       </div>

//                       {/* Email Field */}
//                       <div className="relative">
//                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                           <FaEnvelope className="inline mr-2 text-orange-500" />
//                           Email Address *
//                         </label>
//                         <div className={`relative rounded-xl border-2 ${activeField === 'email' ? 'border-orange-500 ring-2 ring-orange-100' : 'border-gray-200'} bg-white transition-all`}>
//                           <input
//                             type="email"
//                             name="email"
//                             value={formData.email}
//                             onChange={handleChange}
//                             onFocus={() => setActiveField('email')}
//                             onBlur={() => setActiveField('')}
//                             required
//                             className="w-full pl-4 pr-4 py-3.5 bg-transparent outline-none placeholder-gray-400 text-gray-800"
//                             placeholder="your.email@example.com"
//                           />
//                         </div>
//                       </div>
//                     </div>

//                     {/* Phone Field */}
//                     <div className="relative">
//                       <label className="block text-sm font-medium text-gray-700 mb-2">
//                         <FaPhone className="inline mr-2 text-orange-500" />
//                         Phone Number
//                       </label>
//                       <div className={`relative rounded-xl border-2 ${activeField === 'phone' ? 'border-orange-500 ring-2 ring-orange-100' : 'border-gray-200'} bg-white transition-all`}>
//                         <input
//                           type="tel"
//                           name="phone"
//                           value={formData.phone}
//                           onChange={handleChange}
//                           onFocus={() => setActiveField('phone')}
//                           onBlur={() => setActiveField('')}
//                           className="w-full pl-4 pr-4 py-3.5 bg-transparent outline-none placeholder-gray-400 text-gray-800"
//                           placeholder="(555) 123-4567"
//                         />
//                       </div>
//                     </div>

//                     {/* Address Section */}
//                     <div className="space-y-4">
//                       <div className="flex items-center space-x-2">
//                         <div className="p-2 bg-orange-100 rounded-lg">
//                           <FaHome className="text-orange-600" />
//                         </div>
//                         <h3 className="text-lg font-semibold text-gray-800">Project Address (Optional)</h3>
//                       </div>

//                       <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                         <div className="relative">
//                           <input
//                             type="text"
//                             name="address.street"
//                             value={formData.address.street}
//                             onChange={handleChange}
//                             onFocus={() => setActiveField('address.street')}
//                             onBlur={() => setActiveField('')}
//                             className="w-full px-4 py-3.5 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none transition"
//                             placeholder="Street address"
//                           />
//                         </div>
//                         <div className="relative">
//                           <input
//                             type="text"
//                             name="address.city"
//                             value={formData.address.city}
//                             onChange={handleChange}
//                             onFocus={() => setActiveField('address.city')}
//                             onBlur={() => setActiveField('')}
//                             className="w-full px-4 py-3.5 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none transition"
//                             placeholder="City"
//                           />
//                         </div>
//                       </div>

//                       <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
//                         <div className="relative">
//                           <input
//                             type="text"
//                             name="address.state"
//                             value={formData.address.state}
//                             onChange={handleChange}
//                             onFocus={() => setActiveField('address.state')}
//                             onBlur={() => setActiveField('')}
//                             className="w-full px-4 py-3.5 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none transition"
//                             placeholder="State"
//                           />
//                         </div>
//                         <div className="relative">
//                           <input
//                             type="text"
//                             name="address.zipCode"
//                             value={formData.address.zipCode}
//                             onChange={handleChange}
//                             onFocus={() => setActiveField('address.zipCode')}
//                             onBlur={() => setActiveField('')}
//                             className="w-full px-4 py-3.5 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none transition"
//                             placeholder="ZIP Code"
//                           />
//                         </div>
//                         <div className="relative">
//                           <div className="flex items-center">
//                             <FaGlobe className="absolute left-3 text-gray-400" />
//                             <input
//                               type="text"
//                               name="address.country"
//                               value={formData.address.country}
//                               onChange={handleChange}
//                               onFocus={() => setActiveField('address.country')}
//                               onBlur={() => setActiveField('')}
//                               className="w-full pl-10 pr-4 py-3.5 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none transition"
//                               placeholder="Country"
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Message */}
//                     <div className="relative">
//                       <label className="block text-sm font-medium text-gray-700 mb-2">
//                         Project Details *
//                       </label>
//                       <textarea
//                         name="message"
//                         value={formData.message}
//                         onChange={handleChange}
//                         onFocus={() => setActiveField('message')}
//                         onBlur={() => setActiveField('')}
//                         required
//                         rows="4"
//                         className="w-full px-4 py-3.5 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:ring-2 focus:ring-orange-100 outline-none placeholder-gray-400 text-gray-800 resize-none transition"
//                         placeholder="Describe your project requirements, timeline, and any specific needs..."
//                       />
//                     </div>

//                     {/* Submit Button */}
//                     <button
//                       type="submit"
//                       disabled={isSubmitting}
//                       className={`w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold py-4 rounded-xl transition-all duration-300 transform hover:-translate-y-0.5 hover:shadow-xl flex items-center justify-center group ${
//                         isSubmitting ? 'opacity-75 cursor-not-allowed' : 'hover:from-orange-600 hover:to-orange-700'
//                       }`}
//                     >
//                       {isSubmitting ? (
//                         <>
//                           <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
//                           Sending...
//                         </>
//                       ) : (
//                         <>
//                           <FaPaperPlane className="mr-3 group-hover:translate-x-1 transition-transform" />
//                           Send Project Inquiry
//                         </>
//                       )}
//                     </button>
//                   </form>
//                 ) : (
//                   <div className="text-center py-12">
//                     <div className="w-20 h-20 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
//                       <FaCheckCircle className="text-white text-3xl" />
//                     </div>
//                     <h3 className="text-2xl font-bold text-gray-900 mb-3">Inquiry Sent Successfully!</h3>
//                     <p className="text-gray-600 mb-6 max-w-md mx-auto">
//                       Thank you for contacting Laminance. Our team will review your project details and get back to you within 24 hours.
//                     </p>
//                     <button
//                       onClick={() => setIsSubmitted(false)}
//                       className="text-orange-600 hover:text-orange-700 font-semibold inline-flex items-center group"
//                     >
//                       Send another inquiry
//                       <FaArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
//                     </button>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Bottom CTA */}
//       <section className="py-12 px-4">
//         <div className="max-w-4xl mx-auto text-center">
//           <div className="bg-gradient-to-r from-orange-50 to-white rounded-3xl p-8 border border-orange-100">
//             <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
//               Ready to Start Your Dream Project?
//             </h2>
//             <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
//               Contact us today for a free consultation and quote.
//             </p>
//             <div className="flex flex-col sm:flex-row gap-4 justify-center">
//               <a 
//                 href="tel:8624506069"
//                 className="inline-flex items-center justify-center bg-orange-600 text-white font-semibold px-6 sm:px-8 py-3.5 rounded-xl hover:bg-orange-700 transition-all duration-300 transform hover:-translate-y-0.5"
//               >
//                 <FaPhone className="mr-3" />
//                 Call: (862) 450-6069
//               </a>
//               <button
//                 onClick={() => document.querySelector('form')?.scrollIntoView({ behavior: 'smooth' })}
//                 className="inline-flex items-center justify-center bg-white text-orange-600 font-semibold px-6 sm:px-8 py-3.5 rounded-xl border-2 border-orange-200 hover:border-orange-300 hover:bg-orange-50 transition-all duration-300"
//               >
//                 <FaPaperPlane className="mr-3" />
//                 Send Another Message
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default ContactPage;